import {
  EdgeScenarioOverrideSchema,
  NodeScenarioOverrideSchema,
  type EdgeScenarioOverride,
  type NodeScenarioOverride,
} from '../contracts';

/**
 * SPEC-009 §86/plan §10 — override values obey the exact same validation as
 * base metric inputs (SPEC-008 schemas), never a separately duplicated rule
 * set. Returns `null` on an invalid value instead of throwing (FM-005:
 * reject the field, preserve prior valid state).
 */
export function validateNodeOverride(candidate: unknown): NodeScenarioOverride | null {
  const parsed = NodeScenarioOverrideSchema.safeParse(candidate);
  return parsed.success ? parsed.data : null;
}

export function validateEdgeOverride(candidate: unknown): EdgeScenarioOverride | null {
  const parsed = EdgeScenarioOverrideSchema.safeParse(candidate);
  return parsed.success ? parsed.data : null;
}

/** SPEC-009 §33/plan §22 — `sum(reverseShare) == 1` within floating-point tolerance. */
export function isReverseShareSumValid(shares: readonly number[], tolerance = 1e-6): boolean {
  if (shares.length === 0) return false;
  const sum = shares.reduce((total, value) => total + value, 0);
  return Math.abs(sum - 1) <= tolerance;
}
